import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = null;

const selectId = (_, { payload }) => payload?.id;

export default createReducer(initialState, {
  [actionTypes.APPLICATION_IS_READY_SUCCESS]: selectId,
});
